module.exports = __webpack_public_path__ + "img/list-alt.d48d341d.svg";